// extracted by mini-css-extract-plugin
export default {"btn":"ReponsePhoto_btn__2VZa-","invisible":"ReponsePhoto_invisible__Uvvvf","asset":"ReponsePhoto_asset__510LV","div":"ReponsePhoto_div__K+xTb"};